import { Component } from '@angular/core';

@Component({
  selector: 'app-contratos-pagamento',
  templateUrl: './pagamento-contrato.component.html',
  styleUrl: './pagamento-contrato.component.css'
})
export class ContratosPagamentoComponent {

}
